export type OperationState = {
  operationState: 'edit-success' | 'add-success' | 'add-success-with-ocr';
};

export const replaceState = () => {
  window.history.replaceState({state: ''}, '');
};
